import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { GuideTooltip } from '../../../theme/components/GuideTooltip';
import { FormAuthors, initialsOf } from '../VisitConcepts.Functions';

interface VisitConceptAuthorBadgeProps {
  authors: FormAuthors;
}

/**
 * Iniciales del profesional que completó el formulario (EMR `createdById`), con el nombre completo al pasar el
 * mouse o con foco. Si otro profesional lo modificó después, el tooltip también lo dice. Sin nombre resuelto no
 * se muestra nada: el id solo no le dice nada al usuario.
 */
const VisitConceptAuthorBadge: React.FC<VisitConceptAuthorBadgeProps> = ({ authors }) => {
  const { t } = useTranslation();
  const author = authors.created ?? authors.modified;
  if (!author) return null;

  const lines = [
    authors.created ? t('visitConcepts.tree.completedBy', { name: authors.created.name }) : undefined,
    authors.modified && authors.modified.id.toLowerCase() !== authors.created?.id.toLowerCase()
      ? t('visitConcepts.tree.modifiedBy', { name: authors.modified.name })
      : undefined,
  ].filter((line): line is string => !!line);
  const description = lines.join(' · ');

  return (
    <GuideTooltip content={description} relationship="description">
      <span className="vct-author" role="img" aria-label={description} tabIndex={0} data-testid="vct-author">
        {initialsOf(author.name)}
      </span>
    </GuideTooltip>
  );
};

export default VisitConceptAuthorBadge;
